var React = require('react');

function Quote (props) {
    return React.createElement("svg",props,[React.createElement("path",{"className":"st0","d":"M50.85,7.49v25.32h10.23V10.38C57.76,9.21,54.35,8.24,50.85,7.49","key":0}),React.createElement("path",{"className":"st0","d":"M7.08,32.81h10.23V7.38c-3.5,0.72-6.91,1.68-10.23,2.84V32.81z","key":1}),React.createElement("path",{"className":"st0","d":"M28.97,5.86v26.96h10.23V5.89c-1.77-0.11-3.55-0.19-5.35-0.19C32.2,5.7,30.58,5.76,28.97,5.86","key":2})]);
}

Quote.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 68.68 36.75","style":{"enableBackground":"new 0 0 68.68 36.75"},"xmlSpace":"preserve"};

module.exports = Quote;

Quote.default = Quote;
